import React from 'react';
import WorkContainer from '../Components/WorkContainer';

const  My_work = () => (
      <WorkContainer/>
)

export default My_work;
